<!--Para la lista de perfiles-->
<div class="d-flex w-100 align-content-center justify-content-center pointer"
    (click)="app.verMensajes(perfil)" *ngIf="!botones && perfil && (perfil | keyvalue)?.length">
  <div class="me-2">
    <img *ngIf="perfil?.foto?.foto_principal_thumb" width="50px"
        class="rounded-circle pointer thumb-popup" alt="Foto de perfil"
        [src]="perfil?.foto?.foto_principal_thumb" 
        [attr.data-full]="perfil?.foto.foto_principal_grande">
  </div>
  <div class="w-100">
    <div class="row">
      <div class="col">
        {{perfil.first_name | firstWord}}
        <span class="small p-0 m-0 mt-1" *ngIf="perfil.online">
        <i class="small fa-solid fa-circle text-success icon-glow"></i> <span class="ms-1 text-success">En línea</span>
        </span>
        <div class="small text-secondary">
          {{perfil.me_fechahora | cuandoFechas}}
        </div>
        <div [innerHTML]="perfil.me_mensaje | limitarTexto:40" class="small"></div>
      </div>
      <div class="col-auto">
        <span *ngIf="perfil.numero > 0" class="badge rounded-pill text-bg-success">{{perfil.numero}}</span>
      </div>
    </div>
  </div>
</div>

<!--En los mensajes privados-->
<div class="d-flex w-100 align-content-center justify-content-center p-2 bg-iguau text-white rounded-top iguau-chat-profile-link"
    (click)="irPerfil()" *ngIf="botones && perfil && (perfil | keyvalue)?.length">
  <div class="me-2">
    <img *ngIf="perfil?.foto?.foto_principal_thumb" width="50px"
        class="rounded-circle pointer" alt="Abrir perfil"
        [src]="perfil?.foto?.foto_principal_thumb" 
       >
  </div>
  <div class="w-100">
    <div class="row">
      <div class="col">
        <span class="iguau-chat-header-names">{{perfil.first_name | firstWord}}<ng-container *ngIf="app.mascotaCabecera as mascota"> y {{mascota.ma_nombre}}</ng-container></span>
        <img *ngIf="app.mascotaCabecera as mascota" class="iguau-chat-header-pet-photo" [src]="mascota.foto?.foto_thumb" [alt]="mascota.ma_nombre" [title]="mascota.ma_nombre">
        <span class="iguau-chat-online small" *ngIf="perfil.online">
          <i class="fa-solid fa-circle text-success icon-glow" aria-hidden="true"></i><span class="text-success">En línea</span>
        </span>
        <div class="small">
          <span *ngIf="perfil.sexo=='Hombre'"><i class="fa-solid fa-mars"></i></span>
          <span *ngIf="perfil.sexo=='Mujer'"><i class="fa-solid fa-venus"></i></span>
          {{perfil.sexo}} de {{perfil.edad}}<span *ngIf="perfil.ciudad">, {{perfil.ciudad}}</span>
        </div>
      </div>
      <div class="col-auto text-end">
        <div class="d-flex">
          <button type="button" class="mensaje-header-action" *ngIf="app.useridold != 0" (click)="app.atras(); $event.stopPropagation()" aria-label="Volver a conversaciones" title="Volver">
            <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
          </button>
          <button type="button" class="mensaje-header-action mensaje-header-close" data-bs-dismiss="modal" (click)="$event.stopPropagation()" aria-label="Cerrar mensajes" title="Cerrar">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>